import BestProductCard from './BestProductCard'

export default BestProductCard
